import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import premiumPlusTitleIcon from '@/images/premiumPlusTitleIcon.svg';
import { useFlag } from '@/services/featureFlags';
import styled from '@emotion/styled';

const BoxTitle = styled.h3<{ isPremiumPlus: boolean }>`
    color: ${({ isPremiumPlus }) => (isPremiumPlus ? 'var(--Color-Primary-Orange, #FF882E)' : 'var(--Color-Black, #000)')};
    font-family: Manrope, sans-serif;
    font-size: 20px;
    font-weight: 700;
    margin: 0;
`;

const TitleContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

const GreyBox = styled.div`
    display: flex;
    height: 21px;
    padding: 4px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    background: var(--blacks-100, #f3f3f3);
    backdrop-filter: blur(12px);
    white-space: nowrap;
`;

const GreyBoxText = styled.span`
    color: var(--Secondary-Primary, #090604);
    font-feature-settings:
        'liga' off,
        'clig' off;
    font-family: Manrope;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0.15px;
`;

export const PremiumPlusTitleWithIcon = ({ title }: { title: string }) => {
    const creditsToMinutesEnabled = useFlag('credits_to_minutes_enabled', false);
    const COST_STR = creditsToMinutesEnabled ? '23 minutes' : '40 credits';
    return (
        <TitleContainer>
            <BoxTitle isPremiumPlus={title === 'Premium+'}>
                {title}
                {title === 'Premium+' && <MaskedIcon src={premiumPlusTitleIcon} size="16px" style={{ marginLeft: '8px' }} />}
            </BoxTitle>
            {title === 'Premium+' && (
                <GreyBox>
                    <GreyBoxText>{`Costs ${COST_STR}`}</GreyBoxText>
                </GreyBox>
            )}
        </TitleContainer>
    );
};
